import React, { ReactElement } from 'react'
import { AvatarCircle } from './SendStyles'
import { avatarInitials, nameHue } from './sendUtil'

interface IProps {
  name: string
  size?: number
}

/**
 * Initials in a colored circle. The hue is a stable hash of the name so the
 * same recipient is always the same color, like a banking app contact list.
 */
const RecipientAvatar = ({ name, size }: IProps): ReactElement => (
  <AvatarCircle $hue={nameHue(name)} $size={size} aria-hidden='true'>
    {avatarInitials(name)}
  </AvatarCircle>
)

export default RecipientAvatar
